/**
 * Returns the props needed to wire credit gating into Chat.Root.
 *
 * Usage:
 * ```tsx
 * const creditGate = useCreditGateProps();
 * <Chat.Root streamOptions={...} {...creditGate}>
 * ```
 */
import { useCallback } from "react";
import { useCreditStore, useIsOutOfCredits } from "~/stores/creditStore";

export function useCreditGateProps() {
  const isInputDisabled = useIsOutOfCredits();

  // Always show the modal when clicking a disabled input, even if
  // previously dismissed. The user is actively trying to use the chat.
  const onDisabledClick = useCallback(() => {
    useCreditStore.setState({ showOutOfCreditsModal: true });
  }, []);

  return { isInputDisabled, onDisabledClick };
}
